export default __webpack_public_path__ + "static/media/StarWars60.b7d7b1ae.wav";